exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarProveedor .h2_title[data-v-a44c11f6] {\n  font-weight: normal;\n}\n", ""]);

// exports
